import { object, string, number, mixed, ObjectSchema, InferType, date, boolean } from "yup";
import { PeriodicityEnum } from "../../../shared/utils/enum/enum";
import { EditarContasAReceberContract } from "../contracts/editar-contas-a-receber";


export const editarContasAReceberSchema: ObjectSchema<EditarContasAReceberContract> = object({
  idSector: string().required("Informe um setor de origem"),
  chartOfAccountsId: string().required("Informe um plano de contas"),
  description: string().optional(),
  totalValue: number()
    .typeError("Valor total deve ser um número")
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
        if (!cleaned) return undefined;
        const valorNumber = Number(cleaned);
        return isNaN(valorNumber) ? undefined : valorNumber;
      }
      return value;
    })
    .required("É obrigatório informar o valor da movimentação!")
    .default(0),
  purchaseDate: date()
    .typeError("Informe uma data válida")
    .required("Informe a data de vencimento"),
  numberOfInstallments: number()
    .required("É obrigatório informar a quantidade de parcelas!")
    .default(1),
  clientId: string().optional(),
  workId: string().optional(),
  periodicity: mixed<PeriodicityEnum>().optional(),
  idNfs: string().optional(),

  anticipateAccount: boolean().optional(),
  newDateDoc: date()
    .nullable()
    .when("anticipateAccount", {
      is: true,
      then: schema => schema.required("É obrigatório passar a data do novo boleto de antecipação"),
      otherwise: schema => schema.notRequired(),
    }),
  newTotalValue: number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
        if (!cleaned) return undefined;
        const valorNumber = Number(cleaned);
        return isNaN(valorNumber) ? undefined : valorNumber;
      }
      return value;
    })
    .when("anticipateAccount", {
      is: true,
      then: schema => schema.required("É obrigatório passar o valor do boleto de antecipação"),
      otherwise: schema => schema.notRequired(),
    }),
});

export type EditarContasAReceberFormData = InferType<typeof editarContasAReceberSchema>;